import React, { useEffect } from 'react';
import MenuTable from '../components/MenuTable';

const Menu: React.FC = () => {
  useEffect(() => {
    document.body.className = 'bg-dark';
    return () => {
      document.body.className = '';
    };
  }, []);

  return (
    <main>
      <section className="breadcrumb-area d-flex align-items-center" style={{backgroundImage: 'url(/images/bg-img/bdrc-bg.jpg)'}}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-12 col-lg-12">
              <div className="breadcrumb-wrap text-center">
                <div className="breadcrumb-title">
                  <h2>Menu</h2>
                  <div className="breadcrumb-wrap">
                    <nav aria-label="breadcrumb">
                      <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/">Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">Menu</li>
                      </ol>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <MenuTable />
    </main>
  );
};

export default Menu;
